import React from 'react';
import PropTypes from 'prop-types';
import {query} from 'api';
import {Image} from '../styles';
import {Slide} from 'ui';

const GaleryPhoto = ({data}) => {
  if (!data) return null;
  return (
    <Slide style={{height: 'auto', width: '60vw', marginBottom: 10}}>
      <Image src={data.source_url} placeholder={false} />
    </Slide>
  );
};

GaleryPhoto.propTypes = {
  data: PropTypes.object,
};

export default GaleryPhoto |> query('getPost', {loadingHidden: true});
